const PickListMaster = (state = {
    unit: [],
    workload: [],
}, action) => {
    switch (action.type) {
        case 'GET_UNIT':
            return state;
        case 'SET_UNIT':
            state.unit = action.payload;
            return state;
        case 'GET_WORKLOAD':
            return state;
        case 'SET_WORKLOAD':
            state.workload = action.payload;
            return state;
        default:
            return state;
    }
};
export default PickListMaster;







